import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import {
  debounceTime,
  fromEvent,
  lastValueFrom,
  map,
  Observable,
  retry,
  tap,
} from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CartService {
  private apiCartUrl = "/carts";
  private apiCartItemUrl = "/cart_items";
  private apiClearCartUrl = "/clear_carts";
  private apiBankAccUrl = "/bank_accounts";
  private apiTransactionUrl = "/transactions";
  private apiTransactionStatusUrl = "/transaction_statuses";
  private apiCancelTransactionUrl = "/cancel_order";
  private apiTransferUrl = "/transfer_proofs";

  #http = inject(HttpClient);

  userCart = signal<any>(null);

  private excepted_key_names: string[] = [];

  _setFilter(obj: any) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v != null)
    );
  }

  _setParams(value: any) {
    if (!value) return;
    const filter: any = this._setFilter(value);
    let params = new HttpParams();
    for (const key in filter) {
      if (Array.isArray(filter[key])) {
        params = params.append(key, JSON.stringify(filter[key]));
      } else {
        params = params.append(key, filter[key]);
      }
    }
    return params;
  }
  _setFormData(object_key: string, value: any) {
    let formData = new FormData();
    for (const key in value) {
      let obj = value[key];
      if (Array.isArray(obj)) {
        obj.forEach((e, i) => {
          if (this.excepted_key_names.includes(key)) {
            formData.append(`${object_key}[${key}][]`, e);
          } else {
            for (const key_i in e) {
              formData.append(`${object_key}[${key}][][${key_i}]`, e[key_i]);
            }
          }
        });
      } else {
        formData.append(`${object_key}[${key}]`, value[key]);
      }
    }
    return formData;
  }

  async getUserCart() {
    const carts = await lastValueFrom(this.getCarts());
    this.userCart.update((_) => carts);
  }

  getCarts(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http.get<any>(`${this.apiCartUrl}?${params}`).pipe(retry(1));
  }
  addCart(id: number) {
    return this.#http
      .post<any>(`${this.apiCartUrl}`, { cart: { course_id: id } })
      .pipe(retry(1));
  }
  removeCartItem(id: number) {
    const payload = {
      course_id: id,
    };
    return this.#http
      .post<any>(`${this.apiCartItemUrl}`, { cart: payload })
      .pipe(retry(1));
  }
  clearCart() {
    return this.#http.get<any>(`${this.apiClearCartUrl}`).pipe(retry(1));
  }
  verifyDiscountCode(payload: any) {
    return this.#http.post<any>(`${this.apiCartUrl}/discount_code`, payload);
  }

  //--------transaction----------//

  getTransactionStatuses(filter?: any) {
    return this.#http
      .get<any>(`${this.apiTransactionStatusUrl}`)
      .pipe(retry(1));
  }
  getTransactions(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiTransactionUrl}?${params}`)
      .pipe(retry(1));
  }
  getTransaction(id: number) {
    return this.#http.get(`${this.apiTransactionUrl}/${id}`).pipe();
  }
  createTransaction(payload: { payment_type_id: number; code?: string }) {
    return this.#http
      .post(`${this.apiTransactionUrl}`, { transaction: payload })
      .pipe();
  }
  verifyTransaction(data: any) {
    const payload = this._setFormData("transfer_proof", data);
    return this.#http.post(`${this.apiTransferUrl}`, payload).pipe();
  }

  cancelTransaction(id: number) {
    return this.#http.put(`${this.apiCancelTransactionUrl}/${id}`, {}).pipe();
  }

  getBankAcc(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiBankAccUrl}?${params}`)
      .pipe(retry(1));
  }
}
